<template>
  <div>
    <div class="notice-text declaration-text">{{ declarationBody }}</div>

    <template v-if="disabled">
      <div class="signed-box mt-1">
        <feather-icon icon="CheckCircleIcon" size="18" class="text-success mr-50" />
        <span>
          Signed by <strong>{{ signedName || "—" }}</strong>
          <template v-if="signedDate">on <strong>{{ signedDate }}</strong></template>
        </span>
      </div>
    </template>

    <template v-else>
      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <b-form-group :label="(declaration && declaration.notice && declaration.notice.ackLabel ? declaration.notice.ackLabel : 'Name (only by an authorised signatory)') + ' *'">
            <validation-provider #default="{ errors }" rules="required" name="Declaration Name">
              <b-form-input v-model="sectionE.name" :state="errors.length ? false : null" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label="Signature *">
        <signature-pad ref="sigDeclaration" :active="active" height="180px" />
      </b-form-group>

      <template v-if="hasRecat">
        <hr />
        <h5>Re-categorisation signature</h5>
        <p class="text-muted small">
          Requested classification: <strong>{{ classificationLabel }}</strong>
        </p>
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group label="Name (only by an authorised signatory)">
              <b-form-input v-model="sectionF.name" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Signature">
          <signature-pad ref="sigRecat" :active="active" height="180px" />
        </b-form-group>
      </template>
    </template>
  </div>
</template>

<script>
// Section E — the client declaration (text from the DECLARATION notice in the schema) with
// name and signature, plus the re-categorisation signature when section F is on the form.
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import SignaturePad from "../SignaturePad.vue";

const CLASSIFICATION_LABELS = {
  Professional: "Professional Client",
  Retail: "Retail Client",
  EligibleCounterparty: "Eligible Counterparty",
};

const FALLBACK_BODY = "By signing this Client Declaration I/we agree to the terms set out in this agreement.";

export default {
  name: "SectionDeclaration",

  components: { ValidationProvider, SignaturePad },

  props: {
    sectionE: { type: Object, required: true },
    sectionF: { type: Object, default: null },
    declaration: { type: Object, default: null },
    hasRecat: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    active: { type: Boolean, default: true },
    signedName: { type: String, default: null },
    signedDate: { type: String, default: null },
  },

  data() {
    return { required };
  },

  computed: {
    declarationBody() {
      return (this.declaration && this.declaration.notice && this.declaration.notice.body) || FALLBACK_BODY;
    },
    classificationLabel() {
      const value = this.sectionF && this.sectionF.classification;
      return CLASSIFICATION_LABELS[value] || value || "—";
    },
  },

  methods: {
    declarationSignature() {
      const pad = this.$refs.sigDeclaration;
      return pad ? pad.save() : null;
    },

    recatSignature() {
      const pad = this.$refs.sigRecat;
      return pad ? pad.save() : null;
    },
  },
};
</script>
